module.exports = __webpack_public_path__ + "media/images/icon-checked-81519bc90299b6efe74d45dbad1a4260.svg";